export const references = [
  { element: 'Na', Ka: 1.041, Kb: 1.067, La: null, Lb: null, be: null },
  { element: 'Mg', Ka: 1.253, Kb: 1.302, La: null, Lb: null, be: null },
  { element: 'Al', Ka: 1.486, Kb: 1.557, La: null, Lb: null, be: null },
  { element: 'Si', Ka: 1.739, Kb: 1.836, La: null, Lb: null, be: null },
  { element: 'P', Ka: 2.013, Kb: 2.139, La: null, Lb: null, be: null },
  { element: 'S', Ka: 2.307, Kb: 2.464, La: null, Lb: null, be: null },
  { element: 'Cl', Ka: 2.621, Kb: 2.815, La: null, Lb: null, be: null },
  { element: 'Ar', Ka: 2.957, Kb: 3.19, La: null, Lb: null, be: null },
  { element: 'K', Ka: 3.312, Kb: 3.589, La: null, Lb: null, be: null },
  { element: 'Ca', Ka: 3.69, Kb: 4.012, La: null, Lb: null, be: null },
  { element: 'Sc', Ka: 4.088, Kb: 4.46, La: null, Lb: null, be: null },
  { element: 'Ti', Ka: 4.508, Kb: 4.931, La: null, Lb: null, be: null },
  { element: 'V', Ka: 4.949, Kb: 5.426, La: null, Lb: null, be: null },
  { element: 'Cr', Ka: 5.411, Kb: 5.946, La: null, Lb: null, be: null },
  { element: 'Mn', Ka: 5.894, Kb: 6.489, La: null, Lb: null, be: null },
  { element: 'Fe', Ka: 6.398, Kb: 7.057, La: null, Lb: null, be: null },
  { element: 'Co', Ka: 6.924, Kb: 7.648, La: null, Lb: null, be: null },
  { element: 'Ni', Ka: 7.471, Kb: 8.263, La: null, Lb: null, be: null },
  { element: 'Cu', Ka: 8.04, Kb: 8.904, La: null, Lb: null, be: null },
  { element: 'Zn', Ka: 8.63, Kb: 9.57, La: 1.012, Lb: 1.043, be: null },
  { element: 'Ga', Ka: 9.241, Kb: 10.263, La: null, Lb: null, be: null },
  { element: 'Ge', Ka: 9.874, Kb: 10.98, La: null, Lb: null, be: null },
  { element: 'As', Ka: 10.53, Kb: 11.724, La: null, Lb: null, be: null },
  { element: 'Se', Ka: 11.207, Kb: 12.494, La: null, Lb: null, be: null },
  { element: 'Br', Ka: 11.907, Kb: 13.289, La: null, Lb: null, be: null },
  { element: 'Kr', Ka: 12.631, Kb: 14.11, La: null, Lb: null, be: null },
  { element: 'Rb', Ka: 13.373, Kb: 14.959, La: null, Lb: null, be: null },
  { element: 'Sr', Ka: 14.14, Kb: 15.833, La: null, Lb: null, be: null },
  { element: 'Y', Ka: 14.931, Kb: 16.735, La: null, Lb: null, be: null },
  { element: 'Zr', Ka: 15.744, Kb: 17.665, La: null, Lb: null, be: null },
  { element: 'Nb', Ka: 16.581, Kb: 18.619, La: null, Lb: null, be: null },
  { element: 'Mo', Ka: 17.441, Kb: 19.605, La: null, Lb: null, be: null },
  { element: 'Tc', Ka: 18.325, Kb: 20.615, La: null, Lb: null, be: null },
  { element: 'Ru', Ka: 19.233, Kb: 21.543, La: null, Lb: null, be: null },
  { element: 'Rh', Ka: 20.165, Kb: 22.72, La: null, Lb: null, be: null },
  { element: 'Pd', Ka: 21.121, Kb: 23.815, La: null, Lb: null, be: null },
  { element: 'Ag', Ka: 22.101, Kb: 24.938, La: null, Lb: null, be: null },
  { element: 'Cd', Ka: 23.106, Kb: 26.091, La: null, Lb: null, be: null },
  { element: 'In', Ka: 24.136, Kb: 27.271, La: null, Lb: null, be: null },
  { element: 'Sn', Ka: 25.191, Kb: 28.481, La: null, Lb: null, be: null },
  { element: 'Sb', Ka: 26.271, Kb: 29.721, La: null, Lb: null, be: null },
  { element: 'Te', Ka: null, Kb: null, La: 3.769, Lb: 4.029, be: null },
  { element: 'I', Ka: null, Kb: null, La: 3.937, Lb: 4.22, be: null },
  { element: 'Xe', Ka: null, Kb: null, La: 4.109, Lb: null, be: null },
  { element: 'Cs', Ka: null, Kb: null, La: 4.286, Lb: 4.619, be: null },
  { element: 'Ba', Ka: null, Kb: null, La: 4.465, Lb: 4.827, be: null },
  { element: 'La', Ka: null, Kb: null, La: 4.65, Lb: 5.041, be: null },
  { element: 'Ce', Ka: null, Kb: null, La: 4.839, Lb: 5.261, be: null },
  { element: 'Pr', Ka: null, Kb: null, La: 5.033, Lb: 5.488, be: null },
  { element: 'Nd', Ka: null, Kb: null, La: 5.229, Lb: 5.721, be: null },
  { element: 'Pm', Ka: null, Kb: null, La: 5.432, Lb: 5.96, be: null },
  { element: 'Sm', Ka: null, Kb: null, La: 5.635, Lb: 6.204, be: null },
  { element: 'Eu', Ka: null, Kb: null, La: 5.845, Lb: 6.455, be: null },
  { element: 'Gd', Ka: null, Kb: null, La: 6.056, Lb: 6.712, be: null },
  { element: 'Tb', Ka: null, Kb: null, La: 6.272, Lb: 6.977, be: null },
  { element: 'Dy', Ka: null, Kb: null, La: 6.494, Lb: 7.246, be: null },
  { element: 'Ho', Ka: null, Kb: null, La: 6.719, Lb: 7.524, be: null },
  { element: 'Er', Ka: null, Kb: null, La: 6.947, Lb: 7.809, be: null },
  { element: 'Tm', Ka: null, Kb: null, La: 7.179, Lb: 8.1, be: null },
  { element: 'Yb', Ka: null, Kb: null, La: 7.414, Lb: 8.4, be: null },
  { element: 'Lu', Ka: null, Kb: null, La: 7.654, Lb: 8.708, be: null },
  { element: 'Hf', Ka: null, Kb: null, La: 7.898, Lb: 9.021, be: null },
  { element: 'Ta', Ka: null, Kb: null, La: 8.145, Lb: 9.342, be: null },
  { element: 'W', Ka: null, Kb: null, La: 8.396, Lb: 9.671, be: null },
  { element: 'Re', Ka: null, Kb: null, La: 8.651, Lb: 10.008, be: null },
  { element: 'Os', Ka: null, Kb: null, La: 8.91, Lb: 10.354, be: null },
  { element: 'Ir', Ka: null, Kb: null, La: 9.174, Lb: 10.706, be: null },
  { element: 'Pt', Ka: null, Kb: null, La: 9.441, Lb: 11.069, be: null },
  { element: 'Au', Ka: null, Kb: null, La: 9.712, Lb: 11.44, be: null },
  { element: 'Hg', Ka: null, Kb: null, La: 9.987, Lb: 11.821, be: null },
  { element: 'Tl', Ka: null, Kb: null, La: 10.267, Lb: 12.211, be: null },
  { element: 'Pb', Ka: null, Kb: null, La: 10.55, Lb: 12.612, be: null },
  { element: 'Bi', Ka: null, Kb: null, La: 10.837, Lb: 13.021, be: null },
  { element: 'Po', Ka: null, Kb: null, La: 11.129, Lb: 13.445, be: null },
  { element: 'At', Ka: null, Kb: null, La: 11.425, Lb: 13.874, be: null },
  { element: 'Rn', Ka: null, Kb: null, La: 11.725, Lb: 14.313, be: null },
  { element: 'Fr', Ka: null, Kb: null, La: 12.029, Lb: 14.768, be: null },
  { element: 'Ra', Ka: null, Kb: null, La: 12.338, Lb: 15.233, be: null },
  { element: 'Ac', Ka: null, Kb: null, La: 12.65, Lb: 15.71, be: null },
  { element: 'Th', Ka: null, Kb: null, La: 12.967, Lb: 16.199, be: null },
  { element: 'Pa', Ka: null, Kb: null, La: 13.288, Lb: 16.699, be: null },
  { element: 'U', Ka: null, Kb: null, La: 13.612, Lb: 17.217, be: null },
];
